import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { environment } from "../../../environments/environment"
import { JSONRpcResponse } from "../../Interfaces/JSONRpcResponse"
import { JSONRpc } from "../service-jsonrpc"

@Injectable({
	providedIn: "root",
})
export class ImpressionService {
	constructor(private http: HttpClient) { }

	list(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.impression:disableForm",
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	print(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.impression:print",
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	synthese(
		idMembre: any,
		syntheseCode: string,
		idType: any = "v2",
		viewOptions: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.impression:synthese",
			params: {
				idMembre: idMembre,
				syntheseCode: syntheseCode,
				idType: idType,
				viewOptions: viewOptions,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	syntheseList(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: "2.0",
			method: "webservice.impression:syntheseList",
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

}
